// ActivitiesContext.js
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useSelector } from "react-redux";
import useFetch from "../hooks/useFetch";
import {
  API_Q_MEDALS_LIST,
  API_Q_MEDALS,
  GET_ACTIVITIES,
  API_GAME,
  API_Q_UPDATE_FAVORITE,
  API_FREE_CAN_PLAY,
} from "../constants/api";
import * as Sentry from "@sentry/react";
import APlayGame from "../features/NewActivities/APlayGame/APlayGame";
import AddTaskToUser from "../features/NewActivities/AddTaskToUser/AddTaskToUser";
import AModalInfoActivities from "../features/NewActivities/AModalInfoActivities/AModalInfoActivities";
import { Auth } from "aws-amplify";
import FavoriteMessage from "../features/NewActivities/FavoriteActivities/FavoriteMenssage/FavoriteMessage";
import ModalLimitPlays from "../components/ModalLimitPlays/ModalLimitPlays";
import * as h from "../helpers/index";
import * as routes from "../constants/routes";
import ModalReward from "../components/ModalReward";
import ModalReceiveGoal from "../components/ModalReceiveGoal";
import useGoalCelebration from "../hooks/useGoalCelebration";
import ModalLimitPlaysTest from "../features/PersonalizedTraining/components/ModalLimitPlaysTest/ModalLimitPlaysTest";
import {
  useClaimUserGoal,
  useUserGoal,
  useUserMedalById,
} from "@hooks/useUserInfos";
import { useUserAccountInfos } from "hooks/useUserInfos";

const ActivitiesContext = createContext();

export const useActivities = () => useContext(ActivitiesContext);

export const ActivitiesProvider = ({ children }) => {
  const [openGame, setOpenGame] = useState(null);
  const [taskActivity, setTaskActivity] = useState(null);
  const [infoActivity, setInfoActivity] = useState(null);
  const [infoActivityIsQuiz, setInfoActivityIsQuiz] = useState(false);
  const [openModalFree, setOpenModalFree] = useState(null);

  //Controla modal limites de jogadas quiz individual
  const [openModalQuiz, setOpenModalQuiz] = useState(false);
  const [openMedal, setOpenMedal] = useState(null);
  const {
    // activeUser,
    session,
    loadingSession,
  } = useSelector((state) => state.session);
  const {
    data: activeUser,
    isLoading: isLoadingUserInfos,
    isError: hasErrorUserInfos,
  } = useUserAccountInfos();
  const [activities, setActivities] = useState(null);
  // const [medal, setMedal] = useState(null);
  const [showMsg, setShowMsg] = useState(false);
  const [activeTabContext, setactiveTabContext] = useState(null);
  const [blockActivity, setBlockActivity] = useState(true);
  const [redirectOnClose, setRedirectOnClose] = useState(routes.R_ACTIVTS);
  const [sendToAchievements, setSendToAchievements] = useState(false);
  const [closeScreen, setCloseScreen] = useState(false);
  const [hideFavoriteButton, setHideFavoriteButton] = useState(false);
  const [modalGoalOpen, setModalGoalOpen] = useState(false);
  const [activeGoal, setActiveGoal] = useState(null);
  const [goalConfig, setGoalConfig] = useState({
    daily: { conquest: "day", coins: "5", goal: 2, owned: false, progress: 0 },
    weekly: {
      conquest: "week",
      coins: "50",
      goal: 14,
      owned: false,
      progress: 0,
    },
    monthly: {
      conquest: "month",
      coins: "500",
      goal: 60,
      owned: false,
      progress: 0,
    },
  });
  const {
    data: medal,
    isLoadingMedal,
    isErrorMedal,
  } = useUserMedalById(infoActivity?.id);

  const { isCelebrating, startCelebration } = useGoalCelebration();
  const [
    _activities,
    activitiesIsLoading,
    activitiesHasError,
    fetchActivities,
  ] = useFetch({
    autoInit: false,
  });
  const [favorited, isLoadingFavorited, hasErrorFavorited, fetchMyFavorited] =
    useFetch({
      autoInit: false,
    });

  const [
    refreshedMedals,
    isRefreshingMedals,
    refreshMedalsError,
    fetchMyMedals,
  ] = useFetch({
    autoInit: false,
  });

  const isLoading = isLoadingUserInfos || isRefreshingMedals;
  const hasError = hasErrorUserInfos || Boolean(refreshMedalsError);

  const {
    data: myGamification,
    refetch: refetchGoal,
    isFetching: isFetchingGoal,
    isError: hasErrorGoal,
  } = useUserGoal({ enabled: false });
  const { mutate: claimUserGoal, isPending: isClaimingGoal } = useClaimUserGoal();
  const [claimingGoalId, setClaimingGoalId] = useState(null);
  const [claimGoalErrorId, setClaimGoalErrorId] = useState(null);

  const [isAuthLoading, setIsAuthLoading] = useState(true);

  const [userData, isLoadingFetch, error, fetchUserData] = useFetch({
    autoInit: false,
  });

  const activeUserSub = activeUser?.sub;

  const sessionSub = session?.sub || session?.my_user?.parent_sub;
  const targetSub = activeUserSub || sessionSub || null;
  const lastFetchedSubRef = useRef(undefined);

  const refreshedMedalsUserSubRef = useRef(null);

  const myMedals = useMemo(() => {
    const refreshedDataBelongsToCurrentUser =
      refreshedMedalsUserSubRef.current === activeUser?.sub;

    return {
      ...(activeUser ?? {}),
      ...(refreshedDataBelongsToCurrentUser ? refreshedMedals : {}),
    };
  }, [activeUser, refreshedMedals]);

  const loadUserData = useCallback(
    async (ignoreMedals = false) => {
      setIsAuthLoading(true);
      try {
        let userSub = targetSub;

        // FALLBACK (F5): Se o Redux ainda não reidratou
        if (!userSub) {
          try {
            const user = await Auth.currentAuthenticatedUser();
            userSub =
              user?.attributes?.sub ||
              user?.signInUserSession?.idToken?.payload?.sub;
          } catch (authErr) {
            console.log("Aguardando sessão no F5...", authErr);
          }
        }

        const queryParam = ignoreMedals ? "?ignoreMedals=true" : "";

        if (userSub) {
          fetchUserData({
            url: `${API_Q_MEDALS}/${userSub}${queryParam}`,
            // onSuccess: (data) => setUserData(data),
          });
        } else {
          fetchUserData({
            url: API_Q_MEDALS_LIST,
            forceWithouAuth: true,
            //onSuccess: (data) => setUserData(data),
          });
        }
      } catch (err) {
        console.error("Erro em loadUserData:", err);
      } finally {
        setIsAuthLoading(false);
      }
    },
    [targetSub, fetchUserData],
  );

  useEffect(() => {
    if (myGamification) {
      setGoalConfig((currentGoalConfig) => Object.keys(currentGoalConfig).reduce(
        (finalConfig, keyConfig) => {
          const currentConfig = currentGoalConfig[keyConfig];
          const conquest = currentConfig.conquest;

          finalConfig[keyConfig] = {
            ...currentConfig,
            progress: myGamification[`amount_played_${conquest}`],
            owned:
              myGamification[`amount_played_${conquest}_status`] !== "active",
          };

          return finalConfig;
        },
        {},
      ));

      setClaimGoalErrorId((currentErrorId) => {
        if (!currentErrorId) return null;

        const conquestByGoalId = {
          daily: "day",
          weekly: "week",
          monthly: "month",
        };
        const conquest = conquestByGoalId[currentErrorId];

        if (!conquest) return currentErrorId;

        return myGamification[`amount_played_${conquest}_status`] === "active"
          ? currentErrorId
          : null;
      });
    }
  }, [myGamification]);

  const goalUserSub = activeUser?.sub || session?.sub;

  useEffect(() => {
    setClaimingGoalId(null);
    setClaimGoalErrorId(null);
  }, [goalUserSub]);

  const refreshGamification = useCallback(() => {
    if (!goalUserSub) return;

    return refetchGoal({ cancelRefetch: false });
  }, [goalUserSub, refetchGoal]);

  const claimGoal = useCallback(
    (goalId) => {
      const config = goalConfig[goalId];
      if (!session || !config || isClaimingGoal) return;

      setActiveGoal(config);
      setClaimingGoalId(goalId);
      setClaimGoalErrorId(null);

      claimUserGoal(
        {
          userSub: activeUser?.sub || session?.sub,
          conquest: config.conquest,
        },
        {
          onSuccess: () => {
            const claimedGoal = { ...config, owned: true };

            refreshedMedalsUserSubRef.current = null;
            setGoalConfig((currentConfig) => ({
              ...currentConfig,
              [goalId]: claimedGoal,
            }));
            setClaimGoalErrorId(null);
            setModalGoalOpen(true);
            startCelebration();
          },
          onError: () => {
            setClaimGoalErrorId(goalId);
          },
          onSettled: () => {
            setClaimingGoalId(null);
          },
        },
      );
    },
    [
      activeUser,
      claimUserGoal,
      goalConfig,
      isClaimingGoal,
      session,
      startCelebration,
    ],
  );

  const handleChange = (event, newValue) => {
    setactiveTabContext(newValue);
  };

  const getRecommendedActivity = (_activity) => {
    if (!Array.isArray(activities)) return [];
    return activities.filter((activity) => {
      return activity.id === _activity.id;
    });
  };
  const openFavoriteMessage = (activity) => {
    const newFavoritedStatus = !activity.favorited; // Inverte o estado atual
    if (newFavoritedStatus) {
      setShowMsg(true); // Mostra a mensagem se foi favoritado
    }
  };

  const CloseButton = (redirectOnClose = null) => {
    if (redirectOnClose) setRedirectOnClose(redirectOnClose);
    setCloseScreen(true);
  };

  useEffect(() => {
    let timer;
    if (showMsg) {
      timer = setTimeout(() => {
        setShowMsg(false);
      }, 3000); // 3 segundos
    }
    return () => clearTimeout(timer); // limpa se desmontar ou mudar antes
  }, [showMsg]);

  const [
    freeCanPlay,
    isLoadingFreeCanPlay,
    errorFreeCanPlay,
    fetchFreeCanPlay,
  ] = useFetch({
    autoInit: false,
  });

  const isFree = h.checkIsShowingModalLimit(session);
  const [medalReward, setMedalReward] = useState([]);

  // Quantidade de jogadas gratuitas de jogos normais
  const gamePlays = Number(freeCanPlay?.plays_free);

  // Quantidade de jogadas gratuitas de quiz
  const quizPlays = Number(freeCanPlay?.quiz_plays_free);

  //Estado verifica se jogo foi aberto dentro do quiz
  const [openGameIsQuiz, setOpenGameIsQuiz] = useState(false);

  //* Regra: quiz usa quiz_plays_free e jogos normais usam plays_free

  useEffect(() => {
    if (isFree) {
      fetchFreeCanPlay({
        url: API_FREE_CAN_PLAY + "?read=only",
        method: "GET",
      });
    } else {
      setBlockActivity(false);
    }
  }, [isFree]);

  // Define se a atividade deve ser bloqueada baseado nas jogadas disponíveis
  useEffect(() => {
    // Se não tiver dados ou jogo aberto, não executa
    if (!freeCanPlay) return;

    // Se o jogo aberto for dentro do quiz, verifica se tem jogadas
    if (openGameIsQuiz === true) {
      setBlockActivity(quizPlays <= 0);
    } else {
      // Se for jogo normal, verifica jogadas normais
      setBlockActivity(gamePlays <= 0);
    }
  }, [freeCanPlay, openGameIsQuiz]);

  const isAuthUser =
    Auth &&
    "user" in Auth &&
    !!Auth.user &&
    ((Auth.user.attributes && Auth.user.attributes.sub) ||
      (Auth.user.signInUserSession &&
        Auth.user.signInUserSession.idToken &&
        Auth.user.signInUserSession.idToken.payload &&
        Auth.user.signInUserSession.idToken.payload.sub));

  // Função para atualizar as medalhas do usuário
  const refreshMedals = (ignoreMedals = false) => {
    let userSub = "";
    if (activeUser && activeUser.sub) {
      userSub = activeUser.sub;
    }
    if (isAuthUser) {
      refreshedMedalsUserSubRef.current = userSub;
      const urlMedals =
        API_Q_MEDALS + `/${userSub}${ignoreMedals ? "?ignoreMedals=true" : ""}`;
      fetchMyMedals({
        url: urlMedals,
      });
    } else {
      refreshedMedalsUserSubRef.current = null;
      fetchMyMedals({
        url: API_Q_MEDALS_LIST,
        forceWithouAuth: true,
      });
    }
  };

  useEffect(() => {
    // Aguarda o término da verificação da sessão (estado 0)
    if (loadingSession === 0) return;

    if (activitiesIsLoading) return; // Evita chamadas duplicadas enquanto a requisição está em andamento
    if (_activities && Array.isArray(_activities) && _activities.length > 0)
      return; // Evita chamadas duplicadas se já houver atividades carregadas

    const userId = session?.my_user?.parent_sub
      ? session?.my_user?.parent_sub
      : session?.sub || null;

    fetchActivities({
      url: GET_ACTIVITIES(userId),
      method: "GET",
      noAuth: !userId,
      onError: (error) => {
        console.log("fetchActivities error:", error);
      },
    });
  }, [session, loadingSession, _activities, activitiesIsLoading]);

  const getRelatedActivities = (activities) => {
    return activities.map((activity) => {
      // Pega os IDs das atividades relacionadas
      const relatedIds = activity?.similar_activities;
      // Verifica se existem atividades relacionadas
      if (relatedIds && relatedIds.length > 0) {
        // Filtra os jogos relacionados com base nos IDs
        const relatedGames = activities.filter((game) =>
          relatedIds.includes(game.id),
        );

        // Cria um novo array de itens de mídia relacionados
        const newMediaItems = relatedGames
          .filter((game) => game.path)
          .map((game) => ({
            gameName: game.name,
            id: game.id,
            type: game.type,
            url: `${API_GAME}/${game?.path}/${
              game.type === "jogo" ? "jogo_imagem_.jpg" : "audio_imagem_.jpg"
            }`,
          }));
        // Adiciona a lista de atividades relacionadas à atividade original
        activity.related_activities_list = newMediaItems;
      }
      // Retorna a atividade com a nova lista de atividades relacionadas
      return activity;
    });
  };

  useEffect(() => {
    if (_activities && Array.isArray(_activities)) {
      const filteredVisibleActivities = _activities?.filter(
        (activity) => activity?.visible,
      );

      if (Array.isArray(filteredVisibleActivities)) {
        // Pega os favoritos salvos no objeto myMedals (se existir)
        const storedFavorites = myMedals?.games_data || {};

        // Monta as atividades já com favoritos e relacionados
        const merged = getRelatedActivities(
          filteredVisibleActivities.map((activity) => ({
            ...activity,
            favorited:
              storedFavorites.hasOwnProperty(activity.id?.toString()) &&
              storedFavorites[activity.id.toString()]?.favorited,
          })),
        );

        setActivities(merged);
      } else {
        console.warn("🚨 _activities não é um array válido:", _activities);
        Sentry.captureMessage(
          "Atividades inválidas: _activities não é um array",
          "warning",
        );
        setActivities([]); // fallback
      }
    }
  }, [_activities, myMedals]);

  // Favoritar
  const handleFavorited = async (activity) => {
    try {
      fetchMyFavorited({
        url: API_Q_UPDATE_FAVORITE(activity.id),
        method: "POST",
      });

      setActivities((prev) =>
        prev.map((item) =>
          item.id === activity.id
            ? { ...item, favorited: !item.favorited }
            : item,
        ),
      );

      window.dispatchEvent(new Event("favoritesUpdated"));
    } catch (error) {
      console.error("Erro ao atualizar favoritos:", error);
    }
  };

  // Quando abre um jogo, busca quantas jogadas ainda tem
  useEffect(() => {
    if (!openGame) return;
    let urlParam = "?read=only";

    // Se o usuário tem acesso ao quiz, adiciona o parâmetro na URL
    if (openGameIsQuiz) {
      urlParam += "&quiz=true";
    }

    // Se for usuário free ou tiver acesso ao quiz, busca as jogadas disponíveis
    if (openGameIsQuiz || isFree) {
      fetchFreeCanPlay({
        url: API_FREE_CAN_PLAY + urlParam,
        method: "GET",
      });
    }
  }, [openGame, isFree, openGameIsQuiz]);

  // Verifica se acabou as jogadas e abre o modal correto
  useEffect(() => {
    if (!session) return;

    // MODAL ACABOU JOGADAS DENTRO DO QUIZ
    // Se o jogo aberto for um quiz e não houver mais jogadas de quiz, abre modal quiz
    if (openGame && openGameIsQuiz === true && quizPlays === 0) {
      setOpenGame(null);
      setOpenModalQuiz(true);
      return;

      // Se não for quiz e não houver mais jogadas de jogos normais, abre modal free
    } else if (openGame && openGameIsQuiz === false && gamePlays === 0) {
      setOpenModalFree(true);
    }
  }, [blockActivity, openGameIsQuiz, openGame, session, gamePlays, quizPlays]);

  return (
    <ActivitiesContext.Provider
      value={{
        openGame,
        setOpenGame,
        taskActivity,
        setTaskActivity,
        infoActivity,
        setInfoActivity,
        openMedal,
        setOpenMedal,
        handleFavorited,
        myMedals,

        activities,
        isLoading,
        favorited,
        isLoadingFavorited,
        hasErrorFavorited,
        showMsg,
        setShowMsg,
        getRecommendedActivity,
        setActivities,
        openFavoriteMessage,
        handleChange,
        activeTabContext,
        blockActivity,
        setMedalReward,
        medalReward,
        setactiveTabContext,
        hideFavoriteButton,
        setHideFavoriteButton,
        goalConfig,
        hasGoalData: Boolean(myGamification),
        isFetchingGoal,
        hasErrorGoal,
        claimGoal,
        claimingGoalId,
        claimGoalErrorId,
        refreshGamification,
        refreshMedals,
        openGameIsQuiz,
        setOpenGameIsQuiz,
        setOpenModalQuiz,
        setOpenModalFree,
        userData,
        loadUserData,
        infoActivityIsQuiz,
        setInfoActivityIsQuiz,
      }}
    >
      {children}
      {openGame && !blockActivity && (
        <APlayGame refreshMedals={refreshMedals} />
      )}
      <AddTaskToUser
        activity={taskActivity}
        setActivity={setTaskActivity}
        changeTab={handleChange}
      />
      <AModalInfoActivities
        infoActivity={infoActivity}
        setInfoActivity={setInfoActivity}
        medal={medal}
        openMedal={openMedal}
        setOpenMedal={setOpenMedal}
        setOpenGame={setOpenGame}
        handleFavorited={handleFavorited}
        getRecommendedActivity={getRecommendedActivity}
        setTaskActivity={setTaskActivity}
        openFavoriteMessage={openFavoriteMessage}
        showMsg={showMsg}
        hideFavoriteButton={hideFavoriteButton}
        infoActivityIsQuiz={infoActivityIsQuiz}
      />
      <FavoriteMessage show={showMsg} changeTab={handleChange} />
      <ModalLimitPlays
        openModal={openModalFree}
        setOpenModal={setOpenModalFree}
        setOpenGame={setOpenGame}
        setInfoActivity={setInfoActivity}
      />
      {/* Modal limites de jogadas: quiz individual */}
      <ModalLimitPlaysTest
        openModalQuiz={openModalQuiz}
        setOpenModal={setOpenModalQuiz}
        setOpenGame={setOpenGame}
        setInfoActivity={setInfoActivity}
      />
      <ModalReward
        rewards={medalReward}
        CloseButton={CloseButton}
        setSendToAchievements={setSendToAchievements}
        setInfoActivity={setInfoActivity} // fecha o modal de informações do jogo
        setOpenMedal={setOpenMedal} // fecha o modal da medalha
        setOpenGame={setOpenGame} //fecha o jogo
      />
      <ModalReceiveGoal
        openModal={modalGoalOpen}
        setOpenModal={setModalGoalOpen}
        coinsReceived={activeGoal?.coins}
        setVerifyButtons={() => {}}
      />
    </ActivitiesContext.Provider>
  );
};
